import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-userDs",
  "use": "icon-userDs-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-userDs\">\n    <!-- Generator: Sketch 55.1 (78136) - https://sketchapp.com -->\n    <title>↳icon24/user</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-userDs_↳icon24/user\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M21,21 L3,21 C3,16.02975 7.02975,12 12.001125,12 C16.971375,12 21,16.02975 21,21 Z M7,7 C7,4.23875 9.2375,2 12,2 C14.76125,2 17,4.23875 17,7 C17,9.7625 14.76125,12 12,12 C9.2375,12 7,9.7625 7,7 Z\" id=\"icon-userDs_path\" fill=\"#000000\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/userDs.svg
// module id = jG69
// module chunks = 54